/* created by CoolGuy on 2018/12/9 */
import { observable, action } from 'mobx';
import RootStore from './RootStore';

// 专门管理底部的，否则太乱了
export default class BottomCommentStore {
  rootStore: RootStore;
  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
  }
  @observable showMultiBottom = false;
  @action toggleMultiBottom = (flag?: boolean) => {
    this.showMultiBottom =
      typeof flag === 'boolean' ? flag : !this.showMultiBottom;
  };
}
